import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { replicaInstance } from '~/api/runtimeService';

type MultiInstancesVariables = {
  replicaName: string;
  realm: string;
  environment: string;
};

export const useMultiInstances = () => {
  const queryClient = useQueryClient();

  const fetchMultiInstances = useCallback(
    (variables: MultiInstancesVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'multiInstances',
          variables.realm,
          variables.replicaName
        ],
        queryFn: async () => ({
          data: {
            replicaInstance: await replicaInstance({
              realm: variables.realm,
              replicaName: variables.replicaName
            })
          }
        }),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchMultiInstances };
};
